import styled from 'styled-components';

export default styled.div`
  grid-area: buttons;
  align-self: center;
  justify-self: center;
  width: 3rem;
  text-align: center;
`;
